/* eslint-disable indent */
/* eslint-disable jsx-quotes */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import Loader from '../loader-component/loader';
import ApprovedTestsModal from './modals/ApprovedTestsModal';

import {
    asyncFetchPerformedTests,
    asyncExportTestConducted,
    resetContentExportTestConducted,
} from './tests-conducted.actions';

import './tests-conducted.css';

class TestsConducted extends Component {
    constructor(props) {
        super(props);

        this.state = {
            performedTests: [],
            page: 0,
            limit: 25,
            statusFilter: [],
            statusFilterTranslated: [],
            showSelectStatusFilter: false,
            search: '',
            showDescriptionDateRealized: false,
            center_id: '',
            showModalApprovedTest: false,
            itemToModalApprovedTest: {},
        };
    }

    componentDidMount() {
        const { search, statusFilter, limit, page, center_id } = this.state;
        this.fetchPerfomedTestsToRender({
            search,
            status: statusFilter,
            limit,
            page,
            center_id,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { performed_tests, contentCsvToExport } = this.props;
        const { limit, page, search, statusFilter, center_id } = this.state;

        if (prevProps.performed_tests !== performed_tests) {
            this.setState({ performedTests: performed_tests });
        }

        if (
            prevProps.contentCsvToExport !== contentCsvToExport &&
            contentCsvToExport !== 'data:text/csv;charset=utf-8,'
        ) {
            this.exportPerformedTestsCSV();
        }

        if (
            prevState.limit !== limit ||
            prevState.page !== page ||
            (prevState.search !== search && search && search.trim()) ||
            (prevState.search !== search &&
                prevState.search &&
                prevState.search.trim() &&
                search === '') ||
            prevState.statusFilter !== statusFilter ||
            prevState.center_id !== center_id
        ) {
            this.fetchPerfomedTestsToRender({
                search,
                status: statusFilter,
                limit,
                page,
                center_id,
            });
        }
    }

    exportPerformedTestsCSV() {
        this.csvRef.click();
        this.props.resetContentExportTestConducted();
    }

    fetchPerfomedTestsToRender({ limit, page, search, status, center_id }) {
        this.props.asyncFetchPerformedTests({
            limit,
            page,
            status,
            search,
            center_id,
        });
    }

    getStatusTest({ status }) {
        switch (status) {
            case 'IN_PROGRESS':
                return 'Em andamento';
            case 'APPROVED':
                return 'Aprovado';
            case 'REJECTED':
                return 'Reprovado';
            case 'APPROVED_PENDING':
                return 'Aprovado com pendências';
            case 'WAIT_CORRECTION':
                return 'Esperando Correção';
            case 'APPROVED_REVISION':
                return 'Em revisão';
            case 'DISCARDED':
                return 'Removido';
            default:
                return 'Não identificado';
        }
    }

    getTypeTest({ type }) {
        switch (type) {
            case 'FORMACAO':
                return 'Formação';
            case 'MASTER':
                return 'Master';
            case 'UNIFICADO':
                return 'Unificado';
            default:
                return 'Não identificado';
        }
    }

    getTimeBySeconds({ seconds }) {
        if (seconds < 60) {
            return `0 min e ${seconds} seg`;
        }

        let minutes = 0;
        let restSeconds = seconds;
        for (; restSeconds >= 60; ) {
            minutes += 1;
            restSeconds -= 60;
        }

        return `${minutes} min e ${restSeconds} seg`;
    }

    handleShowDescriptionDateRealized(newShowDescriptionDateRealized) {
        this.setState({
            showDescriptionDateRealized: newShowDescriptionDateRealized,
        });
    }

    handleStatusFilter(value, checked) {
        const { statusFilter } = this.state;

        if (checked) {
            if (!statusFilter.includes(value)) {
                const newStatusFilters = [...statusFilter, value];
                this.setState({
                    statusFilter: newStatusFilters,
                    statusFilterTranslated: newStatusFilters.map(status =>
                        this.getStatusTest({ status }),
                    ),
                });
            }
        } else {
            const newStatusFilters = statusFilter.filter(
                status => value !== status,
            );
            this.setState({
                statusFilter: newStatusFilters,
                statusFilterTranslated: newStatusFilters.map(status =>
                    this.getStatusTest({ status }),
                ),
            });
        }
    }

    handleOpenApprovedTestModal(test) {
        this.setState({
            showModalApprovedTest: true,
            itemToModalApprovedTest: {
                name: test.user.nickname,
                status: test.status,
                testId: test.id,
                tcc: {
                    finish_first_module_date: '',
                    finish_second_module_date: '',
                    finish_master_date: '',
                    attachments: [],
                    coach_name: '',
                    ...test.tcc,
                },
            },
        });
    }

    handleCloseApprovedTestModal() {
        this.setState({
            showModalApprovedTest: false,
            itemToModalApprovedTest: {},
        });
    }

    handleExportCSV() {
        const { center_id, statusFilter } = this.state;
        this.props.asyncExportTestConducted({ center_id, status: statusFilter });
    }

    render() {
        const {
            performedTests,
            limit,
            statusFilter,
            search,
            showDescriptionDateRealized,
            showSelectStatusFilter,
            statusFilterTranslated,
            center_id,
            showModalApprovedTest,
            itemToModalApprovedTest,
            page,
        } = this.state;
        const { loading, centers, contentCsvToExport, courses, classes } = this.props;

        return (
            <section className="container-performed-tests">
                <header className="header">
                    <span className="content-filters">
                        <span>
                            <div className="field search-field">
                                <label>Buscar testes</label>
                                <input
                                    placeholder="Buscar testes"
                                    className="input"
                                    type="text"
                                    onChange={({ target }) =>
                                        this.setState({
                                            search: target.value,
                                        })
                                    }
                                    value={search}
                                />
                            </div>
                            <div className="field">
                                <label>Status</label>
                                {showSelectStatusFilter && (
                                    <span
                                        onClick={() =>
                                            this.setState({
                                                showSelectStatusFilter: !showSelectStatusFilter,
                                            })
                                        }
                                        className="click-out-select"
                                    ></span>
                                )}
                                <div className="container-custom-select">
                                    <span
                                        onClick={() =>
                                            this.setState({
                                                showSelectStatusFilter: !showSelectStatusFilter,
                                            })
                                        }
                                        className="content-select"
                                    >
                                        <p
                                            title={statusFilterTranslated.join(
                                                ', ',
                                            )}
                                        >
                                            {statusFilterTranslated.length > 0
                                                ? statusFilterTranslated.join(
                                                      ', ',
                                                  )
                                                : 'Selecione'}
                                        </p>
                                        <i
                                            className={`fa ${
                                                !showSelectStatusFilter
                                                    ? 'fa-angle-down'
                                                    : 'fa-angle-up'
                                            }`}
                                        />
                                    </span>
                                    {showSelectStatusFilter && (
                                        <span className="content-drop-select">
                                            <div className="container-select-checkbox">
                                                <input
                                                    id="checkAprovedPending"
                                                    type="checkbox"
                                                    checked={statusFilter.includes(
                                                        'APPROVED_PENDING',
                                                    )}
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'APPROVED_PENDING',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                />
                                                <label htmlFor="checkAprovedPending">
                                                    Aprovado com pendências
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    id="checkAproved"
                                                    type="checkbox"
                                                    checked={statusFilter.includes(
                                                        'APPROVED',
                                                    )}
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'APPROVED',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                />
                                                <label htmlFor="checkAproved">
                                                    Aprovado
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'REJECTED',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                    checked={statusFilter.includes(
                                                        'REJECTED',
                                                    )}
                                                    id="checkReproved"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="checkReproved">
                                                    Reprovado
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'IN_PROGRESS',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                    checked={statusFilter.includes(
                                                        'IN_PROGRESS',
                                                    )}
                                                    id="checkInProgress"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="checkInProgress">
                                                    Em andamento
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'APPROVED_REVISION',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                    checked={statusFilter.includes(
                                                        'APPROVED_REVISION',
                                                    )}
                                                    id="checkApprovedRevision"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="checkApprovedRevision">
                                                    Em revisão
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'WAIT_CORRECTION',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                    checked={statusFilter.includes(
                                                        'WAIT_CORRECTION',
                                                    )}
                                                    id="checkApprovedRevision"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="checkApprovedRevision">
                                                    Em Correção
                                                </label>
                                            </div>
                                            <div className="container-select-checkbox">
                                                <input
                                                    onChange={ev =>
                                                        this.handleStatusFilter(
                                                            'DISCARDED',
                                                            ev.target.checked,
                                                        )
                                                    }
                                                    checked={statusFilter.includes(
                                                        'DISCARDED',
                                                    )}
                                                    id="checkDiscarded"
                                                    type="checkbox"
                                                />
                                                <label htmlFor="checkDiscarded">
                                                    Removido
                                                </label>
                                            </div>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="field">
                                <label>Núcleo</label>
                                <select
                                    className="input"
                                    onChange={({ target }) =>
                                        this.setState({
                                            center_id: target.value,
                                        })
                                    }
                                    value={center_id}
                                >
                                    <option value={''}>
                                        Selecione um núcleo
                                    </option>
                                    {centers.map(itemCenter => (
                                        <option
                                            key={itemCenter.id}
                                            value={itemCenter.id}
                                        >
                                            {itemCenter.name} -{' '}
                                            {itemCenter.state}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="field">
                                <label>Quantidade de resultados</label>
                                <select
                                    className="input"
                                    onChange={({ target }) =>
                                        this.setState({
                                            limit: target.value,
                                        })
                                    }
                                    value={limit}
                                >
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </span>
                    </span>
                    <button
                        className="export-btn"
                        type="button"
                        onClick={this.handleExportCSV.bind(this)}
                    >
                        Exportar
                    </button>
                </header>
                <section className="table-grid">
                    <div className="table-grid-header">
                        <span>
                            <p>Nome</p>
                        </span>
                        <span>
                            <p>E-mail</p>
                        </span>
                        <span>
                            <p>Duração do teste</p>
                        </span>
                        <span>
                            <p>Tipo de teste</p>
                        </span>
                        <span className="container-title-date-realized">
                            <p
                                className="title-date-realized"
                                onClick={() =>
                                    this.handleShowDescriptionDateRealized(
                                        !showDescriptionDateRealized,
                                    )
                                }
                                title="Clique para ver mais detalhes"
                            >
                                Realizado em <i className="fa fa-info-circle" />
                            </p>
                            {showDescriptionDateRealized && (
                                <span className="container-info">
                                    <span
                                        className="background-info"
                                        onClick={() =>
                                            this.handleShowDescriptionDateRealized(
                                                !showDescriptionDateRealized,
                                            )
                                        }
                                    ></span>
                                    <span className="content-info">
                                        <span className="header-info">
                                            <h1>Informações</h1>
                                            <i
                                                className="fa fa-times-circle icon"
                                                onClick={() =>
                                                    this.handleShowDescriptionDateRealized(
                                                        !showDescriptionDateRealized,
                                                    )
                                                }
                                            />
                                        </span>
                                        <p>
                                            Os resultados são ordenados pela
                                            data de realização do teste mais
                                            recente para o mais antigo
                                        </p>
                                    </span>
                                </span>
                            )}
                        </span>
                        <span>
                            <p>Status</p>
                        </span>
                        <span>
                            <p>Turma</p>
                        </span>
                        <span>
                            <p>Curso</p>
                        </span>
                        <span>
                            <p>Núcleo</p>
                        </span>
                        <span>
                            <p>Ações</p>
                        </span>
                    </div>
                    {performedTests &&
                        performedTests.length > 0 &&
                        performedTests.map(test => {
                            let currentCourse = courses.find(e=>e.courseId === test.course_id);
                            let currentClasse = classes.find(e=>e.classId === test.class_id);
                            return (<div key={test.id} className="table-grid-line">
                                <span>
                                    <p>{test.user ? test.user.nickname : ''}</p>
                                </span>
                                <span>
                                    <p>{test.user ? test.user.email : ''}</p>
                                </span>
                                <span>
                                    <p>
                                        {this.getTimeBySeconds({
                                            seconds: test.duration,
                                        })}
                                    </p>
                                </span>
                                <span>
                                    <p>
                                        {this.getTypeTest({
                                            type: test.test_type,
                                        })}
                                    </p>
                                </span>
                                <span>
                                    <p>
                                        {moment(test.started_at).format(
                                            'DD/MM/YYYY HH:mm',
                                        )}
                                    </p>
                                </span>
                                <span>
                                    <p>
                                        {this.getStatusTest({
                                            status: test.status,
                                        })}
                                    </p>
                                </span>
                                <span>
                                    <p>{currentClasse ? currentClasse.className : test.class_id}</p>
                                </span>
                                <span>
                                    <p>{currentCourse ? currentCourse.courseName : test.course_id}</p>
                                </span>
                                <span>
                                    <p>
                                        {test.center.name} - {test.center.state}
                                    </p>
                                </span>
                                <span>
                                    {['APPROVED', 'APPROVED_REVISION', 'WAIT_CORRECTION' ,'APPROVED_PENDING'].includes(test.status) && (
                                        <button
                                            onClick={() =>
                                                this.handleOpenApprovedTestModal(
                                                    test,
                                                )
                                            }
                                        >
                                            Detalhes
                                        </button>
                                    )}
                                </span>
                            </div>);
                        }
                    )}
                </section>
                <span className="warn-description">
                    Para resultados mais precisos, refine sua pesquisa.
                </span>
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
                {showModalApprovedTest && (
                    <ApprovedTestsModal
                        currentFilters={{
                            search,
                            status: statusFilter,
                            limit,
                            page,
                            center_id,
                        }}
                        data={itemToModalApprovedTest}
                        handleClickOutPortal={this.handleCloseApprovedTestModal.bind(
                            this,
                        )}
                    />
                )}
                <a
                    style={{ display: 'none' }}
                    ref={csvRef => (this.csvRef = csvRef)}
                    href={contentCsvToExport}
                    download={`performed-tests-${moment()
                        .utc()
                        .format('YYYY-DD-MM-HH-mm-ss')}.csv`}
                />
            </section>
        );
    }
}

const mapStateToProps = ({ testsConducted, onlineTests, courses, classes }) => ({
    performed_tests: testsConducted.performed_tests,
    loading: onlineTests.loading,
    courses: courses.data || [],
    classes: classes.data || [],
    centers: testsConducted.centers,
    contentCsvToExport: testsConducted.contentCsvToExport,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncFetchPerformedTests,
            asyncExportTestConducted,
            resetContentExportTestConducted,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(TestsConducted);



// WEBPACK FOOTER //
// ./src/components/tests-conducted/tests-conducted.js